import {ApplicationConfigManager} from "../types";

const usePermissions = () => {
    //TODO add the fallback option as well - call the API if config is empty
    const config = ApplicationConfigManager.getInstance().getConfig();
    return {rawPermissions: config.rawPermissions, permissions: config.permissions};
};

export default usePermissions;
